import { spacing } from '@hubble/tokens/web';

const SIZE_TO_MARGIN_MAP = {
  sm: spacing[4],
  md: spacing[8],
  lg: spacing[12],
  xl: spacing[16]
};
const validChildren = ['Avatar', 'CryptoIcon', 'FiatIcon', 'FileIcon', 'IconBadge', 'MerchantIcon'];

export { SIZE_TO_MARGIN_MAP, validChildren };
